const AdminForm = ({ newUser, setNewUser, errors, setErrors, isEdit }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* First Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          First Name<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          maxLength={250}
          value={newUser.firstname}
          onChange={(e) => {
            setNewUser({ ...newUser, firstname: e.target.value });
            setErrors((prev) => ({ ...prev, firstname: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${
            errors.firstname ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="Enter first name"
        />
        {errors.firstname && (
          <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>
        )}
      </div>

      {/* Last Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
        <input
          type="text"
          maxLength={250}
          value={newUser.lastname}
          onChange={(e) => setNewUser({ ...newUser, lastname: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter last name"

        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email<span className="text-red-500">*</span></label>
        <input
          type="email"
          value={newUser.email}
          readOnly={isEdit}
          onChange={isEdit ? undefined : (e) => {
            setNewUser({ ...newUser, email: e.target.value });
            setErrors((prev) => ({ ...prev, email: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.email ? "border-red-500" : "border-gray-300"} ${isEdit ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""}`}
          placeholder="Enter email address"
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>

      {/* Company */}
      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
        <input
          type="text"
          value={newUser.company}
          onChange={(e) => setNewUser({ ...newUser, company: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter company name"
        />
        {errors.company && <p className="text-red-500 text-xs mt-1">{errors.company}</p>}

      </div> */}

      {/* Status */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select
          value={newUser.status}
          onChange={(e) => setNewUser({ ...newUser, status: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
        >
          <option value="">Select status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="suspended">Suspended</option>
        </select>
      </div>
    </div>
  );
};
export default AdminForm;